import { Button } from '@/components/ui/button';
import { Modal } from '@/components/ui/modal';
import { api } from '@/redux/api';

type ConfirmResponseNotificationModalProps = {
  isOpen: boolean;
  onCancel: () => void;
  onSend: () => void;
  unitIds?: number[];
  notificationText: string;
};

export default function ConfirmResponseNotificationModal({
  isOpen,
  onCancel,
  onSend,
  unitIds = [],
  notificationText,
}: ConfirmResponseNotificationModalProps) {
  const [sendResponseNotification] = api.useSendAnnouncementToUnitMutation();

  return (
    <Modal
      buttonItems={[
        <Button key="cancel" onClick={onCancel} variant="secondary">
          Cancel
        </Button>,
        <Button
          key="confirm"
          onClick={async () => {
            onSend();
            await sendResponseNotification({
              unitIds,
              notificationType: 'responseNotification',
              notificationText,
            });
          }}
          variant="primary"
        >
          Send Response Notification
        </Button>,
      ]}
      open={isOpen}
      setOpen={onCancel}
      title="Confirm Response Notification"
    >
      <div>
        <p>
          Are you sure you want to send the following response notification?
        </p>
        <div className="mt-4 rounded-md bg-gray-50 p-3">
          <p className="font-semibold">Message:</p>
          <p className="mt-1">{notificationText}</p>
        </div>
        <p className="mt-4">
          This response notification will be sent to{' '}
          <span className="font-semibold">{unitIds.length}</span> unit
          {unitIds.length ? 's' : ''}.
        </p>
      </div>
    </Modal>
  );
}
